import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Textfit } from 'react-textfit';

export default function MultipleChoice({ currentQuestion, ...props }) {

  var qImage

  if ((currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.subject == "measurements")) {
    qImage = require('../assets/Measurements/Images/' + currentQuestion.image);
  }


  if ((currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.subject == "statistics")) {
    qImage = require('../assets/Statistics/Images/' + currentQuestion.image);
  }

  if (currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.subject == "geometry") {
    var currImage = currentQuestion.image;
    var correctAnswerName;
    //gets correct answer name for testing
    for (let i = 0; i < currentQuestion.answers.length; i++) {
      if (currentQuestion.answers[i].correct == true)
        correctAnswerName = currentQuestion.answers[i].value;
    }
    //check if image is certain images then change it
    if (currentQuestion.image == "grid2squares.jpg") {
      if (correctAnswerName == "4,3")
        currImage = "grid2squares43.jpg"
      else if (correctAnswerName == "2,5") {
        currImage = "grid2squares25.jpg";
      }
      else if (correctAnswerName == "5,2") {
        currImage = "grid2squares52.jpg";
      }
      else if (correctAnswerName == "1,5") {
        currImage = "grid2squares15.jpg";
      }
      else if (correctAnswerName == "5,5") {
        currImage = "grid2squares55.jpg";
      }
      else if (correctAnswerName == "5,4") {
        currImage = "grid2squares54.jpg";
      }
    }
    if (currentQuestion.image == "firstquadgrid.jpg") {
      if (correctAnswerName == "2,3")
        currImage = "firstquadgrid23.jpg"
      else if (correctAnswerName == "5,1") {
        currImage = "firstquadgrid51.jpg";
      }
      else if (correctAnswerName == "1,5") {
        currImage = "firstquadgrid15.jpg";
      }
      else if (correctAnswerName == "2,5") {
        currImage = "firstquadgrid25.jpg";
      }
      else if (correctAnswerName == "4,2") {
        currImage = "firstquadgrid42.jpg";
      }
      else if (correctAnswerName == "1,3") {
        currImage = "firstquadgrid13.jpg";
      }
      else if (correctAnswerName == "5,5") {
        currImage = "firstquadgrid55.jpg";
      }
      else if (correctAnswerName == "5,1") {
        currImage = "firstquadgrid51.jpg";
      }
      else if (correctAnswerName == "3,5") {
        currImage = "firstquadgrid35.jpg";
      }
      else if (correctAnswerName == "5,2") {
        currImage = "firstquadgrid52.jpg";
      }
      else if (correctAnswerName == "4,3") {
        currImage = "firstquadgrid43.jpg";
      }
      else if (correctAnswerName == "2,5") {
        currImage = "firstquadgrid25.jpg";
      }
      else if (correctAnswerName == "5,4") {
        currImage = "firstquadgrid54.jpg";
      }
      else if (correctAnswerName == "3,2"){
        currImage = "firstquadgrid32.jpg";
      }
    }
    if (currentQuestion.image == "Gridsquaremirror.jpg") {
      if (correctAnswerName == "(1,1)(2,1)(2,2)(1,2)") {
        currImage = "Gridsquaremirror11.jpg"
      }
      else if (correctAnswerName == "(2,2)(3,2)(3,3)(2,3)") {
        currImage = "Gridsquaremirror22.jpg"

      }
      else if (correctAnswerName == "(2,3)(3,3)(3,4)(2,4)") {
        currImage = "Gridsquaremirror23.jpg"
      }

      else if (correctAnswerName == "(2,0)(3,0)(3,1)(2,1)") {
        currImage = "Gridsquaremirror20.jpg"
      }

    }
    if (currentQuestion.image == "Gridsquare.jpg") {
      if (correctAnswerName == "(4,2)(5,2)(5,3)(4,3)") {
        currImage = "Gridsquare42.jpg"
      }
      else if (correctAnswerName == "(2,2)(3,2)(3,3)(2,3)") {
        currImage = "Gridsquare22.jpg"
      }
      else if (correctAnswerName == "(5,0)(6,0)(6,1)(5,1)") {
        currImage = "Gridsquare50.jpg"
      }

    }
    if (currentQuestion.image == "fullquadgrid.jpg") {
      if (correctAnswerName == "(4,3)") {
        currImage = "fullquadgrid43"
      }
      else if (correctAnswerName == "(2,-2)") {
        currImage = "fullquadgrid2-2"
      }
      else if (correctAnswerName == "(-4,4)") {
        currImage = "fullquadgrid-44"
      }
      else if (correctAnswerName == "(-4,-2)") {
        currImage = "fullquadgrid-4-2"
      }
      else if (correctAnswerName == "(-3,4)") {
        currImage = "fullquadgrid-34"
      }
      else if (correctAnswerName == "(-4,2)") {
        currImage = "fullquadgrid-42"
      }
      else if (correctAnswerName == "(-3,-3)") {
        currImage = "fullquadgrid-3-3"
      }
      else if (correctAnswerName == "(3,3)") {
        currImage = "fullquadgrid33"
      }
      else if (correctAnswerName == "(2,4)") {
        currImage = "fullquadgrid24"
      }
      else if (correctAnswerName == "(-2,4)") {
        currImage = "fullquadgrid-24"
      }
      else if (correctAnswerName == "(-2,-4)") {
        currImage = "fullquadgrid-2-4"
      }
      else if (correctAnswerName == "(1,1)") {
        currImage = "fullquadgrid11"
      }
      else if (correctAnswerName == "(-1,-1)") {
        currImage = "fullquadgrid-1-1"
      }
      else if (correctAnswerName == "(-1,-1)") {
        currImage = "fullquadgrid-1-1"
      }
      else if (correctAnswerName == "(-1,1)") {
        currImage = "fullquadgrid-11"
      }
      else if (correctAnswerName == "(-4,-1)") {
        currImage = "fullquadgrid-4-1"
      }
      else if (correctAnswerName == "(3,1)") {
        currImage = "fullquadgrid31"
      }
      else if (correctAnswerName == "(3,-2)") {
        currImage = "fullquadgrid3-2"
      }
      else if (correctAnswerName == "(-4,-4)") {
        currImage = "fullquadgrid-4-4"
      }
      else if (correctAnswerName == "(4,4)") {
        currImage = "fullquadgrid44"
      }
      else if (correctAnswerName == "(4,-4)") {
        currImage = "fullquadgrid4-4"
      }
      else if (correctAnswerName == "(-2,-2)") {
        currImage = "fullquadgrid-2-2"
      }
      else if (correctAnswerName == "(4,-1)") {
        currImage = "fullquadgrid4-1"
      }
      else {
        currImage = "fullquadgrid";
      }
      currImage += ".jpg";
    }
    if (currentQuestion.image == "rectlongside.jpg") {
      if (correctAnswerName == "20") {
        currImage = "rectlongside20.jpg";
      }
      else if (correctAnswerName == "45") {
        currImage = "rectlongside45.jpg";
      }
      else if (correctAnswerName == "150") {
        currImage = "rectlongside150.jpg";
      }
      else if (correctAnswerName == "270") {
        currImage = "rectlongside270.jpg";
      }
      else if (correctAnswerName == "8") {
        currImage = "rectlongside8.jpg";
      }
    }
    if (currentQuestion.image == "rectshortside.jpg") {
      if (correctAnswerName == "2") {
        currImage = "rectshortside2.jpg";
      }
      else if (correctAnswerName == "5") {
        currImage = "rectshortside5.jpg";
      }
      else if (correctAnswerName == "7") {
        currImage = "rectshortside7.jpg";
      }
      else if (correctAnswerName == "15") {
        currImage = "rectshortside15.jpg";
      }
      else if (correctAnswerName == "75") {
        currImage = "rectshortside75.jpg";
      }
    }

    var imagePath = currImage.replace(".jpg", ".png");
    console.log(currentQuestion);
    var image = require('../assets/Geometry/Shapes/' + imagePath);
  }

  function FilteredAnswers() {
    return currentQuestion.answers.filter(v => v.value !== "");
  }

  return (
    <>
      <Container>
        <div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            {currentQuestion.subject == "fractions" ? (
              <Question
                type="text"
                disabled
                value={
                  currentQuestion.question !== undefined
                    ? currentQuestion.question.replace("$", "?")
                    : ""
                }
              ><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question) }} />}</span></Question>
            ) : (
                <Question>
                  <Textfit mode="single" style={{ height: "100%" }} > {currentQuestion.question}</Textfit></Question>
              )}

            {props.playAudio && (
              <Button
                style={{
                  alignSelf: "center",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50px",
                  lineHeight: "70px",
                  fontSize: "3em"
                }}
                onClick={() => props.saySentence()}
              >
                <span>Say</span>
              </Button>
            )}
          </div>
          {currentQuestion.question2 !== undefined && currentQuestion.question2 !== "" ?
            <Question
              type="text"
              disabled
              value={
                currentQuestion.question !== undefined
                  ? currentQuestion.question.replace("$", "?")
                  : ""
              }
            ><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question) }} />}</span></Question>
            : ""}
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
          {currentQuestion.image != "" && currentQuestion.subject == "geometry" ? (
            <img src={image}></img>
          ) : (
              <div></div>
            )}
        </div>
        {currentQuestion.subject == "measurements" || currentQuestion.subject == "statistics" ? (
          <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
            {(currentQuestion.image != "" && currentQuestion.image != undefined) && currentQuestion.questionHTML == "" ? (
              <img src={qImage}></img>
            ) : (
                <div></div>
              )}
            {currentQuestion.questionHTML != "" ? (
              <DynamicStyle>
                <div dangerouslySetInnerHTML={{ __html: currentQuestion.questionHTML }}></div>
              </DynamicStyle>
            ) :
              (
                <div></div>
              )}
          </div>
        ) : (
            <div></div>
          )}
        {props.playAudio && (
          <Button
            style={{
              alignSelf: "center",
              width: "100px",
              height: "100px",
              borderRadius: "50px",
              lineHeight: "50px"
            }}
            onClick={() => props.replay()}
          >
            <span>?</span>
          </Button>
        )}
        {console.log(currentQuestion)}
        {currentQuestion.answers !== undefined ? (<div>
          {(currentQuestion.answers[0].value.toString().length < 999) || currentQuestion.subject == "geometry" ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              {
                FilteredAnswers().map(answer => (

                  <Button
                    value={answer.value}
                    onClick={() => props.onSubmit(answer, currentQuestion)}
                  >
                    {answer.value.toString().includes(".jpg") != true ? (
                      <div style={{ height: "80%", width: "100%" }}>
                        <Textfit mode="multi" max="99" style={{ height: "100%" }}>
                        <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                        </Textfit>
                      </div>
                    ) : (
                        <ButtonImage src={require("../assets/Geometry/Shapes/" + answer.value.replace(".jpg", ".png"))} ></ButtonImage>
                      )
                    }
                  </Button>
                ))}
            </div>) : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                {currentQuestion.answers !== undefined &&
                  currentQuestion.answers.map(answer => (
                    <LongButton
                      value={answer.value}
                      style={{ alignSelf: "center", flex: 1, margin: "20px" }}
                      onClick={() => props.onSubmit(answer, currentQuestion)}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </LongButton>
                  ))}
              </div>)}</div>) : ""}

      </Container>
    </>
  );
}

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`

const Container = styled.div`
width:80%;
height:95%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom:100px;
`;

const Question = styled.div`
  background: #FFF;
  user-select: none;
  width: 90%;
  height: 120px;
  line-height: 90px;
  font-size: 4em;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const Button = styled.div`
  text-align: center;
  width: 20%;
  height: 150px;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
const LongButton = styled.div`
  text-align: center;
  width: 80%;
  height: 100px;
  line-height: 50px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;